export const Permissions = [
  "show_dashboard",
  "show_product",
  "create_product",
  "edit_product",
  "delete_product",
  "download_product",
  "show_unit",
  "create_unit",
  "edit_unit",
  "show_category",
  "create_category",
  "edit_category",
  "show_brand",
  "create_brand",
  "edit_brand",
  "show_customer",
  "create_customer",
  "edit_customer",
  "delete_customer",
  "block_customer",
  "show_customerBilling",
  "download_customerBilling",
  "show_customerRequests",
  "approve_customerRequests",
  "deny_customerRequests",
  "show_location",
  "create_location",
  "edit_location",
  "delete_location",
  "show_receipts",
  "create_receipts",
  "edit_receipts",
  "delete_receipts",
  "download_receipts",
  "show_commonVouchers",
  "create_commonVouchers",
  "edit_commonVouchers",
  "delete_commonVouchers",
  "on_off_commonVouchers",
  "show_userVouchers",
  "create_userVouchers",
  "edit_userVouchers",
  "delete_userVouchers",
  "on_off_userVouchers",
  "show_poster",
  "create_poster",
  "edit_poster",
  "delete_poster",
  "show_outstandingBalances",
  "download_allOutstandingBalances",
  "download_particularOutstandingBalances",
  "show_ledger",
  "download_ledger",
  "show_gstReports",
  "download_gstReports",
  "show_employee",
  "create_employee",
  "edit_employee",
  "delete_employee",
  "show_role",
  "create_role",
  "edit_role",
  "delete_role",
  "show_purchase",
  "create_purchase_order",
  "edit_purchase_order",
  "delete_purchase_order",
  "create_purchase_inward",
  "edit_purchase_inward",
  "delete_purchase_inward",
  "create_purchase_return",
  "edit_purchase_return",
  "delete_purchase_return",

  // Production Module Permissions
  "show_production",
  "show_jobslips",
  "create_jobslip",
  "edit_jobslip",
  "delete_jobslip",
  "show_design_recipe",
  "create_design_recipe",
  "edit_design_recipe",
  "delete_design_recipe",
  "show_karigar",
  "create_karigar",
  "edit_karigar",
  "delete_karigar",
];
